import React from 'react'
import { Button } from 'primereact/button'
import { RECONNECTION_CONFIG } from '../config/reconnection.config'

/**
 * Component for manual reconnection state (after all attempts failed)
 */
const ReconnectionManual = ({ displayName, onRetry, onClose, error }) => {
  return (
    <div
      className="reconnection-manual"
      role="alertdialog"
      aria-live="assertive"
      aria-label={RECONNECTION_CONFIG.ARIA_LABELS.ERROR}
    >
      <i className="pi pi-exclamation-triangle warning-icon" aria-hidden="true" />
      <h3>No se pudo conectar automáticamente</h3>
      <p>
        Después de {RECONNECTION_CONFIG.MAX_ATTEMPTS} intentos de reconexión, no se pudo establecer
        la conexión a <strong>{displayName}</strong>.
      </p>

      <div className="error-details">
        <h5>Detalles del error:</h5>
        <p className="">
          {error && error.message === 'Connection failed after all attempts'
            ? 'Todos los intentos de reconexión fallaron'
            : error?.message || 'No se pudo establecer la conexión después de múltiples intentos'}
        </p>
        {error?.attempt && (
          <p className="error-attempt">
            Falló en el intento {error.attempt} de {RECONNECTION_CONFIG.MAX_ATTEMPTS}
          </p>
        )}
      </div>

      <div className="manual-actions">
        <Button
          label="Intentar de nuevo"
          icon="pi pi-refresh"
          onClick={onRetry}
          className="p-button-outlined"
          aria-label={RECONNECTION_CONFIG.ARIA_LABELS.RETRY}
        />
        <Button
          label="Cerrar"
          icon="pi pi-times"
          onClick={onClose}
          className="p-button-danger"
          aria-label={RECONNECTION_CONFIG.ARIA_LABELS.CLOSE}
        />
      </div>
    </div>
  )
}

export default ReconnectionManual
